module.exports = __webpack_public_path__ + "static/media/label-icon-current-state.948d36ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/label-icon-current-state.svg
// module id = 1868
// module chunks = 0